<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/clean-switch')"></span>
    </div>
    <div class="title">请选择清洁时长</div>
		<div class="main clearfix">
			<div class="cell" @click="orderUpdate('household_hour','2','/household-step2')">
				<img src="../../assets/img/household/2.svg">
			</div>

			<div class="cell" @click="orderUpdate('household_hour','3','/household-step2')">
				<img src="../../assets/img/household/3.svg">
			</div>

			<div class="cell" @click="orderUpdate('household_hour','4','/household-step2')">
				<img src="../../assets/img/household/4.svg">
			</div>

			<div class="cell" @click="orderUpdate('household_hour','5','/household-step2')">
				<img src="../../assets/img/household/5.svg">
			</div>

			<div class="cell last" @click="orderUpdate('household_hour','6','/household-step2')">
				<img src="../../assets/img/household/6.svg">
			</div>

			<div class="cell last" @click="orderUpdate('household_hour','8','/household-step2')">
				<img src="../../assets/img/household/8.svg">
			</div>
		</div>


  </div>


</template>

<script>
export default {
  name: 'household-step1',
  data () {
    return {
			showModal: false,
      order:{
        service:'household',
        data:{
          household_hour: 0,
          household_name: "",
          household_phone: "",
          household_state: "NSW",
          household_suburb: "",
          household_street: "",
          household_postcode: ""
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:''
        }
      }
    }
  },

  components: {
  },
  created: function () {
    if (localStorage.order) {
			let validateData = JSON.parse(localStorage.order);
			if (validateData.service == "household"){
      	this.order = JSON.parse(localStorage.order);
			}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.multilayer{
	text-align:center;
	margin:20px 0;
}

.info-box{
	min-height:60px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:13px;
}

.btn{
  width: 250px;
  height: 50px;
	margin-top:10px;
	background: #ddd;
	color:#666;
}
.btn.active{
  color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}
.main{
  padding:30px;
}
.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #eee;
	box-sizing: border-box;
	text-align: center;
	cursor: pointer;
}
.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #eee;
}
.cell.last{
	border-bottom:0;
}
.cell img{
	width:100px;
	margin:15px auto;
}

.cell div{
	margin-top:16px;
	color:#595D68;
}
.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter .modal-container,
.fade-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  min-width:68px;
	padding:0 8px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

</style>



// WEBPACK FOOTER //
// src/pages/household/step1.vue